export default {
  brandId: 'masihotels',
  name: 'Masi Hotels',
  tagline: {
    it: "Benessere e ospitalità sul Lago di Bolsena",
    en: "Wellness and hospitality on Lake Bolsena"
  },
  logoSAK: '/logo-sak-pointer-with-text-horizontal.png',
  logo: '/masi-hotels-logo.png',          // Add actual logo file
  logoLongText: '/masi-hotels-logo.png',          // Add actual logo file
  secondaryLogo: '/logo.png', // SAK logo
  secondaryLogoLongText: '/logo.png', // SAK logo
  colors: {
    primary: '#193441',     // Deep blue/green tone for lakeside feel
    secondary: '#F2F2F2',   // Soft light gray for background
    //accent: '#8CBF3F',      // Olive green inspired by surrounding nature
    accent: '#adadad',      // Grey/green
    background: '#FFFFFF',
    explore: '#000000',          // black explore button
    appKeyGreen: '#31D33A'
  },
  mapCenter: [11.991, 42.645] // Bolsena
};
